import React from 'react';
import styled from 'styled-components';
import { blockPadV, blockPadH, blockW } from 'theme/mixins/padding';
import type { ProjectsIndex as T } from './types';
import ProjectIndexItem from 'components/ProjectIndexItem';

const Wrapper = styled.div`
  ${blockPadV()};
  ${blockPadH()};
`;

const Container = styled.div`
  ${blockW()};
`;

const ProjectTitle = styled.h1`
  padding-top: 3.25rem;
  padding-bottom: 1rem;
`;
const ProjectGrid = styled.div`
  min-height: auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  row-gap: 2.5rem;

  ${({ theme }) => theme.mq.sm`
    grid-template-columns: 1fr 1fr;
  `}

  ${({ theme }) => theme.mq.md`
    gap: 2.5rem;
    row-gap: 5rem;
  `}

  ${({ theme }) => theme.mq.xl`
    min-height: 80vh;
  `}
`;

// TODO: eventually this can be a lazy loading container! :o that would be really sweet
const ProjectsIndex: React.FC<T> = ({ projects }) => {
  return (
    <Wrapper>
      <Container>
        <ProjectTitle>Selected Case Studies</ProjectTitle>
        <ProjectGrid>
          {projects?.map((project, idx) => (
            <ProjectIndexItem key={`${idx}-${project?.title}`} project={project} />
          ))}
        </ProjectGrid>
      </Container>
    </Wrapper>
  );
};

export default ProjectsIndex;
